import { useSelector } from 'react-redux'
import { sortPhotoListByDate } from 'photo-module/photos/ui/photos-gallery/PhotoHelpers'

const usePhotosByDate = () => {
  const photos = useSelector(state => state.galleryPhoto.photos)
  return (photos.length > 0) ? sortPhotoListByDate(photos) : []
}

export default usePhotosByDate
